import script from "./content.vue?vue&type=script&setup=true&lang=js"
export * from "./content.vue?vue&type=script&setup=true&lang=js"

import "./content.vue?vue&type=style&index=0&id=c83bb1c0&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c83bb1c0"]])

export default __exports__